// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_container__R7sXj {
    background-color: var(--black-text);
    color: var(--white-text);
}

.Footer_wrapper__T0psY {
    padding-top: 70px;
    padding-bottom: 70px;
    display: grid;
    grid-template-columns: 45% 55%;
}

.Footer_logo-img__ScVEt {
    width: 35%;
    margin-bottom: 30px;
}

.Footer_logo-img__ScVEt img {
    width: 100%;
    height: 100%;
}

.Footer_social-networks__Hl479 {
    display: flex;
    align-items: center;
    margin-left: 15px;
    gap: 10px;
}

.Footer_social-networks__Hl479 a {
    padding: 10px 10px 2px;
    border-radius: 5px;
    background-color: rgba(255,255,255,0.2);
}

.Footer_social-networks__Hl479 a:hover {
    transform: scale(1.1);
}

.Footer_social-networks__Hl479 a svg:hover {
    fill: #3ACB89;
}

.Footer_links-list__eC5zk {
    display: flex;
    justify-content: space-around;
    font-size: 20px;
    margin-top: 15px;
}

.Footer_links-list__eC5zk ul {
    list-style: none;
}

.Footer_links-list__eC5zk ul li {
    margin-bottom: 10px;
}

.Footer_links-list__eC5zk ul li a {
    text-decoration: none;
    color: var(--white-text);
}

.Footer_links-list__eC5zk ul li a:hover {
    color: var(--green-main);
}

.Footer_copy__V37yO {
    border-top: 1px solid rgba(255, 255, 255, .2);
    text-align: center;
    font-size: 15px;
    padding: 15px 0;
}


@media screen and (max-width: 1536px) {
    .Footer_logo-img__ScVEt {
        width: 45%;
    }
}

@media screen and (max-width: 1200px) {
    .Footer_logo-img__ScVEt {
        width: 55%;
    }

    .Footer_links-list__eC5zk {
        font-size: 18px;
    }
}

@media screen and (max-width: 768px) {
    .Footer_wrapper__T0psY {
        grid-template-columns: 40% 60%;
    }

    .Footer_logo-img__ScVEt {
        width: 85%;
        margin-bottom: 20px;
    }
}

@media screen and (max-width: 576px) {
    .Footer_wrapper__T0psY {
        grid-template-columns: none;
        grid-row-gap: 50px;
    }

    .Footer_logo-img__ScVEt {
        width: 50%;
        margin: 0 auto 15px;
    }

    .Footer_social-networks__Hl479 {
        margin-left: 0;
        justify-content: center;
    }
}

@media screen and (max-width: 480px) {
    .Footer_logo-img__ScVEt {
        width: 70%;
    }

    .Footer_links-list__eC5zk {
        justify-content: space-between;
        padding: 0 5px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.module.css"],"names":[],"mappings":"AAAA;IACI,mCAAmC;IACnC,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,6CAA6C;IAC7C,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;;AAGA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,8BAA8B;IAClC;;IAEA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,kBAAkB;IACtB;;IAEA;QACI,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,8BAA8B;QAC9B,cAAc;IAClB;AACJ","sourcesContent":[".container {\n    background-color: var(--black-text);\n    color: var(--white-text);\n}\n\n.wrapper {\n    padding-top: 70px;\n    padding-bottom: 70px;\n    display: grid;\n    grid-template-columns: 45% 55%;\n}\n\n.logo-img {\n    width: 35%;\n    margin-bottom: 30px;\n}\n\n.logo-img img {\n    width: 100%;\n    height: 100%;\n}\n\n.social-networks {\n    display: flex;\n    align-items: center;\n    margin-left: 15px;\n    gap: 10px;\n}\n\n.social-networks a {\n    padding: 10px 10px 2px;\n    border-radius: 5px;\n    background-color: rgba(255,255,255,0.2);\n}\n\n.social-networks a:hover {\n    transform: scale(1.1);\n}\n\n.social-networks a svg:hover {\n    fill: #3ACB89;\n}\n\n.links-list {\n    display: flex;\n    justify-content: space-around;\n    font-size: 20px;\n    margin-top: 15px;\n}\n\n.links-list ul {\n    list-style: none;\n}\n\n.links-list ul li {\n    margin-bottom: 10px;\n}\n\n.links-list ul li a {\n    text-decoration: none;\n    color: var(--white-text);\n}\n\n.links-list ul li a:hover {\n    color: var(--green-main);\n}\n\n.copy {\n    border-top: 1px solid rgba(255, 255, 255, .2);\n    text-align: center;\n    font-size: 15px;\n    padding: 15px 0;\n}\n\n\n@media screen and (max-width: 1536px) {\n    .logo-img {\n        width: 45%;\n    }\n}\n\n@media screen and (max-width: 1200px) {\n    .logo-img {\n        width: 55%;\n    }\n\n    .links-list {\n        font-size: 18px;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .wrapper {\n        grid-template-columns: 40% 60%;\n    }\n\n    .logo-img {\n        width: 85%;\n        margin-bottom: 20px;\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .wrapper {\n        grid-template-columns: none;\n        grid-row-gap: 50px;\n    }\n\n    .logo-img {\n        width: 50%;\n        margin: 0 auto 15px;\n    }\n\n    .social-networks {\n        margin-left: 0;\n        justify-content: center;\n    }\n}\n\n@media screen and (max-width: 480px) {\n    .logo-img {\n        width: 70%;\n    }\n\n    .links-list {\n        justify-content: space-between;\n        padding: 0 5px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Footer_container__R7sXj`,
	"wrapper": `Footer_wrapper__T0psY`,
	"logo-img": `Footer_logo-img__ScVEt`,
	"social-networks": `Footer_social-networks__Hl479`,
	"links-list": `Footer_links-list__eC5zk`,
	"copy": `Footer_copy__V37yO`
};
export default ___CSS_LOADER_EXPORT___;
